import React from "react";
import "./App.css";
import "fontsource-roboto";
import { MuiThemeProvider } from "@material-ui/core/styles";

import theme from "./theme";
import SignIn from "./pages/SignIn";
import Register from "./pages/Register";
import Home from "./pages/Home";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import UserProvider from "./providers/UserProvider";
import GlobalProvider from "./providers/GlobalProvider";
import LeaderboardProvider from "./providers/LeaderboardProvider";
import { getBot } from "./services/firebase";
import CssBaseline from "@material-ui/core/CssBaseline";

function App() {
  const routes = [
    { path: ["/dashboard", "/problems", "/leaderboard", "/admin"], Component: Home },
    { path: "/signin", Component: SignIn },
    { path: "/register", Component: Register },
  ];
  getBot();
  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline/>
      <div className="App">
        <header className="App-header">
          <Router>
            <GlobalProvider>
              <UserProvider>
                <LeaderboardProvider>
                  <Switch>
                    {routes.map(({ path, Component}) => (
                      <Route key={path} exact path={path} render={(props) => (
                          <Component {...props} />
                      )}/>
                    ))}
                    <Redirect to="/signin" />
                  </Switch>
                </LeaderboardProvider>
              </UserProvider>
            </GlobalProvider>
          </Router>
        </header>
      </div>
    </MuiThemeProvider>
  );
}

export default App;
